<template>
  <el-form
    class="tab_form"
    status-icon
    :model="user"
    :rules="rules"
    ref="user"
  >
    <!-- <div class="error_box size-14">
      <span class="error_msg" v-if="showError">{{ errMsg }}</span>
    </div> -->
    <div class="input_group">
      <div class="login_input">
        <el-form-item class="" prop="loginid">
          <el-input
            id="loginid"
            class="input"
            v-model="user.loginid"
            maxlength="11"
            autocomplete="on"
            :placeholder="formLabel.accountName"
            prefix-icon="el-icon-user"
            @blur="validateUsername"
          ></el-input>
          <span class="red error_msg" slot="error" slot-scope="slotScope">
            <i class="icon el-icon-warning" style=""></i>
            {{ slotScope.error }}
          </span>
        </el-form-item>
      </div>
        <div class="login_input">
        <el-form-item class="" prop="vercode">
          <el-input
            id="vercode"
            class="input_code"
            v-model.trim="user.vercode"
            maxlength="11"
            autocomplete="on"
            :placeholder="formLabel.vercode"
            prefix-icon="el-icon-user"
            :disabled="isValidated"
          ></el-input>
            <el-button
              type="primary"
              class="btn-login-code size-16" 
              @click="sendvercode"
              :disabled="isValidated"
              :loading="isSending"
              >
                {{ isSending ? btntxt : buttonLabel.sendvercode }}
              </el-button>
          <span class="red error_msg" slot="error" slot-scope="slotScope">
            <i class="icon el-icon-warning" style=""></i>
            {{ slotScope.error }}
          </span>
        </el-form-item>
      </div>
    </div>
    <div class="login_btn">
      <el-button
        type="primary"
        class="btn-login size-16"
        :disabled="!user.vercode"
        @click="validateCode"
      >
        {{ buttonLabel.verify}}
      </el-button>
      <el-button
        type="primary"
        class="btn-login size-16"
        @click="back"
      >
        {{buttonLabel.back}}
      </el-button>
    </div>
    
  </el-form>
</template>
<script>
import { isNotNullORBlank, getQueryStr } from "../../utils/utils";
export default {
  data() {
    let validateLoginid = (rule, value, callback) => {
      let _this = this;
      let msg = "";
      if (!value) {
        msg = _this.$t("login_pageText.PLEASEINPUTACC");
        setTimeout(() => {  
          callback(new Error(msg));
        }, 300);
      } else { 
        setTimeout(() => {
          callback();
        }, 300);
      }
    };
   
    let validateVercode = (rule, value, callback) => {
      let _this = this;
      let msg = "";
      if (!value) {
        msg = _this.$t("login_pageText.PLEASEINPUTCODE");
        setTimeout(() => {
          callback(new Error(msg));
        }, 300);
      } else {
        setTimeout(() => {
          callback();
        }, 300);
      }
    };
    return {
      showError: false,
      errMsg: "",
      rules: {
        loginid: [{ validator: validateLoginid, trigger: "blur" }],
        vercode: [{ validator: validateVercode, trigger: "blur" }]
      },
      formLabel: {
        accountName: this.$t("login_pageText.ACCOUNTNAME"),
        vercode: this.$t("login_pageText.VERCODE"),
      },
      buttonLabel: {
        verify: this.$t("forget_pageText.VERIFY"),
        login: this.$t("login_pageText.LOG_IN"),
        sendvercode:this.$t("login_pageText.SEND_VERCODE"),
        back:this.$t("forget_pageText.BACK"),
      }
    };
  },

  props: {
    isSending: {
      type: Boolean,
      default: false
    },
    isValidated: {
      type: Boolean,
      default: true
    },
    btntxt:{
      type: String,
      default: ""
    },
    user: {
      type: Object,
      default: () => {
        return {
          loginid: "",
          langcode: "",
          vercode:"",
        };
      }
    }
  },
  methods: {
    validateUsername(){
        let _this = this;
        _this.$emit("validateUsername");
    },
    sendvercode() {
        let _this = this;
        _this.$emit("sendvercode");
    },
    validateCode(){
        let _this = this;
        _this.$emit("validateCode");
    },
    back(){
        let _this = this;
        _this.$emit("back");
    },
    
  },
  watch: {
    "$i18n.locale"(curVal, oldVal) {
      this.formLabel.accountName = this.$t("login_pageText.ACCOUNTNAME");
      this.formLabel.password = this.$t("login_pageText.PASSWORD");
      this.buttonLabel.logining = this.$t("login_pageText.LOGGINING");
      this.buttonLabel.login = this.$t("login_pageText.LOG_IN");
    },
  }
};
</script>
<style>
.tab_form .el-input__inner {
  height: 50px;
  line-height: 48px;
  /* padding-left: 10px; */
  /* border: 1px solid #bfbfbf; */
}
</style>
<style scoped>
.tab_form {
  /* display: flex; */
  overflow: hidden;
}
.input_group {
  padding: 0 60px;
}
.login_input {
  height: 100px;
  margin: 0 auto;
  /* padding: 0 10px; */
}
.input {
  /* width: 459px; */
  color: #999;
}
.input_code {
  display: inline-block;
  width:200px;
  color: #999;
}
.error_box {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 38px;
  margin: 5px 0;
  color: #e55646;
  text-align: center;
}
.error_msg {
  display: block;
}
.login_btn {
  padding-top: 30px;
  text-align: center;
}
.login_btn_sendcode {
  padding-top: 30px;
  text-align: center;
  width: 100px;
}
.btn-login {
  width: 220px;
  height: 50px;
  /* line-height: 36px; */
  margin: 0 10px 15px 10px;
  font-weight: 700;
}

.btn-login-code {
  display: inline-block;
  width: 220px;
  height: 50px;
  /* float: right; */
  /* line-height: 36px; */
  margin: 2px 0px 15px 35px;
  font-weight: 700;
}

.login_forgot {
  text-align: right;
}

.forgot_link {
  display: inline-block;
  margin-bottom: 10px;
  color: #ffa000;
}

.forgot_link::focus,
.forgot_linke::active {
  color: #ffa000;
}

.login_regist {
  text-align: right;
}

.noaccount {
  display: inline-block;
  color: #666;
}

.regist_link {
  display: inline-block;
  margin-left: 10px;
}

.freeregist {
  color: #666;
}
</style>


